import { atom } from 'recoil';
import { IReceivedMessage } from './types';

export const aReceivedMessages = atom<IReceivedMessage[]>({ key: 'aMessages', default: [] });

export const aSendIdleNotification = atom<boolean>({ key: 'aSendIdleNotification', default: false });
